import { apiC2, apiNGS } from '../../config/api'
import { CallCurrency } from '../../config/apiSinToken'

/* export const listLoans = (params) => {
    return api.get(`/loans-and-deposits${stage}/api/loan-x/v1.0/loan-fulfillment-arrangement/loan-contracts-tree/retrieve/`,params)
} */
export const getSectors = (params) => {
  return apiNGS.get(`api/v1/Sectors/ByCountry?IdCountry=${params}`)
}

export const getActivity = (country, idSector) => {
  return apiNGS.get(
    `api/v1/Activities/ByCountrySector?country=${country}&idSector=${idSector}`,
  )
}

export const getCurrencies = (country) => {
  return apiNGS.get(`api/v1/Currencies/currenciesByCountry/${country}`)
}

export const getDepartments = (country) => {
  return apiNGS.get(`api/v1/Departments/ByCountry?IdCountry=${country}`)
}

export const getMunicipalities = (country) => {
  return apiNGS.get(`api/v1/Municipality/ByDepartment?IdDepartment=${country}`)
}

export const getMiPymeType = () => {
  return apiNGS.get(`api/v1/MiPymeTypes/List`)
}

export const getListForm = (userType, page, pageSize) => {
  return apiC2.get(`/preelegibility/getall`, {
    UserTypeDescription: userType,
    Page: page,
    PageSize: pageSize,
  })
}

export const getListFormFilters = (
  userType,
  page,
  pageSize,
  statusFilter,
  statusOrder,
  projectCodeFilter,
  projectCodeFilterOn,
  projectStage,
  projectStageFilterOn,
  projectsName,
  projectsNameFilterOn,
  date,
  dateFilterOn,
) => {
  return apiC2.get(`preelegibility/getall`, {
    UserTypeDescription: userType,
    IdFormStatusFilter: statusFilter,
    FormStatusOrder: statusOrder,
    PreElegibilityCodeFilter: projectCodeFilter,
    PreElegibilityCodeOrder: projectCodeFilterOn,
    StageFilter: projectStage,
    StageOrder: projectStageFilterOn,
    SubProjectNameFilter: projectsName,
    SubProjectNameOrder: projectsNameFilterOn,
    DateFilter: date,
    DateOrder: dateFilterOn,
    Page: page,
    PageSize: pageSize,
  })
}

export const getListFormDraftFilters = (
  page,
  pageSize,
  statusFilter,
  projectStage,
  DateFilter,
  SubProjectNameFilter,
) => {
  return apiC2.get(`preelegibility/getdraft`, {
    IdFormStatusFilter: statusFilter,
    StageFilter: projectStage,
    Page: page,
    PageSize: pageSize,
    DateFilter: DateFilter,
    SubProjectNameFilter: SubProjectNameFilter,
  })
}

export const getDetailsForms = (idForm) => {
  console.log('desde el api', idForm)
  return apiNGS.get(
    `api/v1/FormPreElegibility/getFormPreElegibilityById/${idForm}`,
  )
}

export const getActualForm = (idForm) => {
  return apiC2.get(`preelegibility/getbyid/${idForm}`)
}

export const updateStatusForms = (
  idForm,
  idFormStatus,
  idUserAzureB2C,
  hasAmountChanges,
  observations,
) => {
  return apiC2.post(`preelegibility/updatestatusform`, {
    idForm: idForm,
    idFormStatus: idFormStatus,
    idUserAzureB2C: idUserAzureB2C,
    hasAmountChanges: hasAmountChanges,
    observations: observations,
  })
}

export const getCurrencyExchange = (params) => {
  return CallCurrency(
    // `//market-data/api/public-reference-data-management-x/v1.0/global-standard-specification/currency-exchange/retrieve`,
    params,
  )
}

export const getCountries = () => {
  return apiNGS.get('api/v1/Countries/Get')
}

export const getClimateThreat = () => {
  return apiNGS.get(`api/v1/ClimateThreat/GetAll`)
}

export const getAdaptationActions = () => {
  return apiNGS.get(`api/v1/AdaptationActions/GetAll`)
}

export const getBusinessLine = () => {
  return apiNGS.get(`api/v1/BusinessLines/GetAll`)
}

export const getQuestions = (idCountry, idSector, idActivity) => {
  return apiNGS.get(
    `api/v1/Questions/ByCountrySectorActivity?IdCountry=${idCountry}&IdSector=${idSector}&IdActivity=${idActivity}`,
  )
}

export const getProjectsCode = (companyId) => {
  return apiC2.get(`/project/getprojectscodebycompanyid/${companyId}`)
}

export const getStage = () => {
  return apiNGS.get(`api/v1/Stages/GetAll`)
}

export const getProjectsName = (companyId, condicion) => {
  return apiNGS.get(
    `api/v1/Projects/GetProjectsNameByCompanyId?CompanyId=${companyId}&Draft=${condicion}`,
  )
}

export const getListDraftForms = (MiPymeTypeOrder, Page, PageSize) => {
  return apiC2.get(`/preelegibility/getdraft`, {
    MiPymeTypeOrder: MiPymeTypeOrder,
    Page: Page,
    PageSize: PageSize,
  })
}

export const getPDF = (idForm, date) => {
  return apiC2.getPDF(`preelegibility/downloadpdf/${idForm}/${date}`)
}

export const getListMypmes = (b2c) => {
  return apiNGS.get(`api/v1/MiPymes/GetMipymesByUser?IdUserAzureB2C=${b2c}`)
}
